import { get, isString } from 'lodash'
import moment, { Moment } from 'moment'

export type TValueDatePicker =
  | { startDate: string; endDate: string }
  | string
  | undefined

export type TParseDateObject = {
  from: Moment
  until: Moment
}

export type TParseDate = TParseDateObject | Moment

export function parseDate(value: TValueDatePicker): TParseDate | undefined {
  if (isString(value)) {
    return moment(value)
  }
  if (value && get(value, 'startDate')) {
    return {
      from: moment(value.startDate),
      until: moment(value.endDate),
    }
  }
  return
}

export const MIN_TIMESTAMP = 0

export const MIN_ISO_STRING = moment(MIN_TIMESTAMP).toISOString()

export const MAX_TIMESTAMP = 2147483647

export const MAX_ISO_STRING = moment(MAX_TIMESTAMP).toISOString()
